import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'cares-b1873',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const functions = getFunctions(app)

// Opt-in local emulators (live Firebase by default; never active in production builds)
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  try {
    // Ports overridable when the defaults are taken by another emulator suite.
    const authPort = Number(import.meta.env.VITE_EMULATOR_AUTH_PORT || 9099)
    const firestorePort = Number(import.meta.env.VITE_EMULATOR_FIRESTORE_PORT || 8080)
    const functionsPort = Number(import.meta.env.VITE_EMULATOR_FUNCTIONS_PORT || 5001)
    connectAuthEmulator(auth, `http://localhost:${authPort}`, { disableWarnings: true })
    connectFirestoreEmulator(db, 'localhost', firestorePort)
    connectFunctionsEmulator(functions, 'localhost', functionsPort)
    console.log('Connected to Firebase emulators')
  } catch (error) {
    console.warn('Failed to connect to emulators:', error)
  }
}

export default app
